import * as React from 'react';
import { Translate } from 'react-redux-i18n';

/** Memoized component to avoid unnecessary re-render */
export const MemoTranslate = React.memo((props: { value: string, tag?: any, className?: string }) => {
    return <Translate value={props.value} tag={props.tag} className={props.className}/>;
});
